export default __webpack_public_path__ + "67e80d143eb27b6cd5b65d007b1406dd.webp";